module.exports = __webpack_public_path__ + "static/img/tohome.d35cef95.png";